import React, { type FC, type PropsWithChildren } from 'react';
import { Box, token } from '@bynder/design-system';
import { IconInfo } from '@bynder/icons';
import generateTestId from 'packages/helpers/testIdHelpers';
import { AlertBodyWrapper, AlertContent, AlertIconWrapper } from './Alert.styled';

type AlertVariant = 'error' | 'warning';

type AlertProps = PropsWithChildren<{
    variant?: AlertVariant;
}>;

const variantStyles: Record<AlertVariant, { background: string; iconColor: string }> = {
    error: { background: token.red500a10, iconColor: token.red500 },
    warning: { background: token.yellow500a10, iconColor: token.yellow600 },
};

export const Alert: FC<AlertProps> = ({ children, variant = 'error' }) => {
    const styles = variantStyles[variant];

    return (
        <Box paddingTop="4" paddingBottom="4" {...generateTestId('designs-bulk-export-modal-alert')}>
            <AlertContent backgroundColor={styles.background}>
                <AlertIconWrapper>
                    <IconInfo style={{ color: styles.iconColor }} />
                </AlertIconWrapper>
                <AlertBodyWrapper>{children}</AlertBodyWrapper>
            </AlertContent>
        </Box>
    );
};
